import React, { Fragment } from 'react'
import useRootStore from '@store/useRootStore'
import { useOnMount } from '@utils/reactExt'
import { observer } from 'mobx-react'
import { isMobile } from 'react-device-detect'
import { message } from 'antd'
import { COUPON_RESULT_CODE } from '@constants/index'
import { ICouponRegisterInfo } from '@protocol/component'
// icon
import { ArrowIco } from '@shared/Icon/ArrowIcon'
import { DiaIco, GmoneyIco } from '@shared/Icon/MoneyIcon'
import PageLoading from '@components/PageLoading'
// css
import {
  TitleWrap,
} from '@styles/base.style'
import { BackBtn, Button } from '@styles/button.style'
import _ from 'lodash'
import { PROPERTY_ID } from 'adv-protocol/src/GameCommon'
import CouponBgCenter from '@assets/images/coupon/coupon-bg-center.png'
import CouponBgBottom from '@assets/images/coupon/coupon-bg-bottom.png'
import NavBar from '@views/Navbar'
import CouponNotice from '../CouponNotice/index'
import { CouponWrap } from '../index.style'
import { appScrollTo, loadOrReload } from '@utils/utils'

const CouponCheck: React.FC = props => {
  const { authStore, routerStore, componentStore, globalStore } = useRootStore()
  const isLoading = componentStore.isCouponLoading !== false

  const goPrevPage = () => {
    if (isMobile) {
      routerStore.goBack()
    } else {
      globalStore.closeGeneralPopup()
    }
  }

  useOnMount(() => {
    if (!authStore.isSignedIn || !componentStore.couponRegisterInfos || componentStore.couponRegisterInfos.length < 1) {
      loadOrReload('/')
    }

    componentStore.setCouponInputViewCallFromCouponCheckView(true)
    componentStore.validateCoupons()

    if (isMobile) {
      setTimeout(() => {
        appScrollTo(1)
      }, 0)
    }
  })

  const couponRegisterInfos = componentStore.couponRegisterInfos
  if (!couponRegisterInfos) {
    componentStore.initCouponRegisterInfo()
  }

  const moneyCouponAmountSummary = _.sumBy(_.filter(couponRegisterInfos, info => {
    return info.propertyId === PROPERTY_ID.MONEY || info.propertyId === PROPERTY_ID.NEW_BET_TICKET_G
  }), info => info.amount)
  const diaCouponAmountSummary = _.sumBy(_.filter(couponRegisterInfos, info => {
    return info.propertyId === PROPERTY_ID.DIA
  }), info => info.amount)

  const moneyCouponCount = _.size(_.filter(couponRegisterInfos, info => {
    return info.propertyId === PROPERTY_ID.MONEY || info.propertyId === PROPERTY_ID.NEW_BET_TICKET_G
  }))
  const diaCouponCount = _.size(_.filter(couponRegisterInfos, info => {
    return info.propertyId === PROPERTY_ID.DIA
  }))

  // let contentWarpStyle
  // if (!isMobile) {
  //   contentWarpStyle = { overflow: 'auto', height: 'calc(100% - 40px)', background: 'none' }
  // }

  const getErrorCouponRegisterInfo = (infos: ICouponRegisterInfo.Schema[]) => {
    return infos.filter(info => {
      return info.resultCode !== COUPON_RESULT_CODE.UNKNOWN && info.resultCode !== COUPON_RESULT_CODE.OK
    })
  }

  const registerCouponsSuccess = () => {
    message.info('쿠폰 등록이 완료됐습니다. 메세지함을 확인해주세요.')

    componentStore.initCouponIdsVanillaTextAndCouponRegisterInfo()
    goPrevPage()
  }

  const registerCouponsFail = () => {
    message.info('쿠폰번호를 확인해주세요.')
  }

  const registerCouponsCompleteHandler = () => {
    const infos = componentStore.couponRegisterInfos
    const errorCouponIds = getErrorCouponRegisterInfo(infos)
    if (infos.length > 0 && errorCouponIds.length === 0) {
      registerCouponsSuccess()
    } else {
      registerCouponsFail()
    }
  }

  const getErrorCouponRegisterInfoIndex = () => {
    const indexes = []
    const infos = componentStore.couponRegisterInfos
    for (const [index, info] of infos.entries()) {
      if (info.resultCode !== COUPON_RESULT_CODE.UNKNOWN && info.resultCode !== COUPON_RESULT_CODE.OK) {
        indexes.push(index + 1)
      }
    }
    return indexes
  }

  const registerCouponsValidate = () => {
    let result = true
    const errorIds = getErrorCouponRegisterInfo(componentStore.couponRegisterInfos)
    if (errorIds && errorIds.length > 0) {
      result = false
      const indexes = getErrorCouponRegisterInfoIndex()
      message.info(`${indexes.join(',')}번째 쿠폰 번호를 확인해주세요.`)
    }
    return result
  }

  const onClickRegisterCoupons = async () => {
    if (registerCouponsValidate()) {
      await componentStore.registerCoupons()
      registerCouponsCompleteHandler()
    }
  }

  const getCouponInfoErrorMessage = info => {
    let errorMessage = ''
    switch (info.resultCode) {
      case COUPON_RESULT_CODE.COUPON_DEF_NOT_FOUND:
      case COUPON_RESULT_CODE.COUPON_NOT_FOUND:
        errorMessage = '사용할 수 없는 쿠폰'
        break
      case COUPON_RESULT_CODE.COUPON_ALREADY_USED_OTHER:
      case COUPON_RESULT_CODE.COUPON_ALREADY_USED_SELF:
        errorMessage = '이미 사용한 쿠폰'
        break
      case COUPON_RESULT_CODE.COUPON_EXPIRED:
        errorMessage = '사용 기간 만료'
        break
      default:
        errorMessage = '쿠폰 번호를 확인해주세요.'
    }
    return errorMessage
  }

  const isErrorCouponResultCode = info => {
    return info.resultCode !== COUPON_RESULT_CODE.UNKNOWN && info.resultCode !== COUPON_RESULT_CODE.OK
  }

  const renderCouponList = () => {
    return (<ul className="coupon-list--box--check-list">
      {
        couponRegisterInfos && couponRegisterInfos.map((info, index) => {
          const couponListItemClassName = `coupon-list--box--check-list--item ${isErrorCouponResultCode(info) ? 'error' : ''}`
          return (
            <li key={index.toString()} className={couponListItemClassName}>
              <span className="coupon-list--box--check-list--item--num">{index + 1}</span>
              <span className="coupon-list--box--check-list--item--info">
                <span className="coupon-list--box--check-list--item--info--num">{info.couponId}</span>
                <span className="coupon-list--box--check-list--item--info--money">{info.amount ? info.amount.toLocaleString() : 0}
                  {info.propertyId === PROPERTY_ID.DIA && <DiaIco/>}
                  {(info.propertyId === PROPERTY_ID.MONEY
                    || info.propertyId === PROPERTY_ID.NEW_BET_TICKET_G) && <GmoneyIco/>}
                </span>
                <span className="coupon-list--box--check-list--item--info--error-message">
                  {getCouponInfoErrorMessage(info)}
                </span>
              </span>
            </li>
          )
        })
      }
    </ul>)
  }

  if (isLoading) {
    return (<PageLoading/>)
  }

  return (
    <Fragment>
      {isMobile && (
        <TitleWrap className="title-wrap white">
          <BackBtn onClick={() => routerStore.goBack()}>
            <ArrowIco/>
          </BackBtn>
        </TitleWrap>
      )}

      <CouponWrap className={!isMobile && 'pc-coupon-wrap'}>
        <CouponNotice/>

        <div className="coupon-list coupon-check">

          <img src={CouponBgCenter} alt="" className="coupon-bg center"/>

          <ul className="coupon-info">

            {diaCouponCount > 0 &&
            <li className="coupon-info--item">
              <span className="amount"><DiaIco/>{`${diaCouponAmountSummary.toLocaleString()}`}</span>
              <span className="count">{`${diaCouponCount.toLocaleString()}개`}</span>
            </li>
            }

            {moneyCouponCount > 0 &&
            <li className="coupon-info--item">
              <span className="amount"><GmoneyIco/>{`${moneyCouponAmountSummary.toLocaleString()}`}</span>
              <span className="count">{`${moneyCouponCount.toLocaleString()}개`}</span>
            </li>
            }
          </ul>

          <div className="coupon-list--box">
            {renderCouponList()}
          </div>

          <Button TP className="coupon-btn" onClick={onClickRegisterCoupons}>
            <img src={CouponBgBottom} alt="" className="coupon-bg bottom"/>
            쿠폰 등록
          </Button>
        </div>
      </CouponWrap>
      {isMobile && <NavBar key="CouponCheck:NavBar"/>}
    </Fragment>
  )
}

export default observer(CouponCheck)
